import { register } from 'swiper/element/bundle'
import { UcoastEl } from '@/scripts/core/UcoastEl'
import { qsOptional } from '@/scripts/core/global'

register()

type SwiperEl = HTMLElement & {
	swiper?: { slidePrev: () => void; slideNext: () => void }
	initialize?: () => void
}

export class BeforeAfterStatsGallery extends UcoastEl {
	static htmlSelector = 'before-after-stats-gallery'

	connectedCallback() {
		super.connectedCallback()
		const swiperEl = qsOptional<HTMLElement>('swiper-container', this) as SwiperEl | undefined
		const prev = qsOptional<HTMLButtonElement>('[data-prev]', this)
		const next = qsOptional<HTMLButtonElement>('[data-next]', this)
		if (!swiperEl || !prev || !next) return

		const slide = (dir: 'prev' | 'next') => {
			const sw = swiperEl.swiper
			if (!sw) return
			if (dir === 'prev') sw.slidePrev()
			else sw.slideNext()
		}

		prev.addEventListener('click', () => slide('prev'))
		next.addEventListener('click', () => slide('next'))
	}
}
